



































































































































































import { Component, Vue } from "@/shared/vuepack";
import { AdminUmbLinkedAccountSearchRequest, UmbLinkedAccount, UmbLinkedAccountSearchCategory } from "@/admin/types";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import moment from "moment";
import { useUmbAdminDeleteLinkedAccountStore } from "@/admin/store/umbAdminDeleteLinkedAccount";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary,
  },
  filters: {
    formatDate (value) {
      if (!value) {
        return "";
      }
      return moment(String(value)).format("MM/DD/YYYY");
    }
  }
})
export default class AdminUtilityPendingTx extends Vue {
  $validator: Validator;
  umbAdminDeleteLinkedAccountStore = useUmbAdminDeleteLinkedAccountStore();

  accountNumberLocal = "";
  emailAddressLocal = "";
  firstNameLocal = "";
  lastNameLocal = "";

  get canDelete (): boolean { return this.umbAdminDeleteLinkedAccountStore.canSearch; }

  get accountSearchEnabled (): boolean {
    if (!this.accountNumberLocal) {
      return false;
    }

    if (!this.umbAdminDeleteLinkedAccountStore.canSearch) {
      return false;
    }

    const accountNumber = this.accountNumberLocal.trim();
    if (!accountNumber || accountNumber.length === 0) {
      return false;
    }

    return true;
  }

  get emailSearchEnabled (): boolean {
    if (!this.emailAddressLocal) {
      return false;
    }

    if (!this.umbAdminDeleteLinkedAccountStore.canSearch) {
      return false;
    }

    const emailAddress = this.emailAddressLocal.trim();
    if (!emailAddress || emailAddress.length === 0) {
      return false;
    }

    return true;
  }

  get firstNameSearchEnabled (): boolean {
    if (!this.firstNameLocal) {
      return false;
    }

    if (!this.umbAdminDeleteLinkedAccountStore.canSearch) {
      return false;
    }

    const firstName = this.firstNameLocal.trim();
    if (!firstName || firstName.length === 0) {
      return false;
    }

    return true;
  }

  get lastNameSearchEnabled (): boolean {
    if (!this.lastNameLocal) {
      return false;
    }

    if (!this.umbAdminDeleteLinkedAccountStore.canSearch) {
      return false;
    }

    const lastName = this.lastNameLocal.trim();
    if (!lastName || lastName.length === 0) {
      return false;
    }

    return true;
  }

  get nameSearchEnabled (): boolean { return this.firstNameSearchEnabled && this.lastNameSearchEnabled; }

  submitDeleteRequest (ula: UmbLinkedAccount) {
    this.umbAdminDeleteLinkedAccountStore.delete(ula);
  }

  onSubmitAccountNumber (): void {
    this.umbAdminDeleteLinkedAccountStore.search({
      accountNumber: this.accountNumberLocal,
      emailAddress: null,
      firstName: null,
      lastName: null,
      searchCategory: UmbLinkedAccountSearchCategory.byAccount
    });
  }

  onSubmitEmailAddress (): void {
    this.umbAdminDeleteLinkedAccountStore.search({
      accountNumber: null,
      emailAddress: this.emailAddressLocal,
      firstName: null,
      lastName: null,
      searchCategory: UmbLinkedAccountSearchCategory.byEmail
    });
  }

  isVerified (status: string): boolean {
    return status === "verified";
  }

  onSubmitName (): void {
    this.umbAdminDeleteLinkedAccountStore.search({
      accountNumber: null,
      emailAddress: null,
      firstName: this.firstNameLocal,
      lastName: this.lastNameLocal,
      searchCategory: UmbLinkedAccountSearchCategory.byName
    });
  }
}
